import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export const ProjectCard = ({ project, index, variant = 'default' }) => {
  return (
    <Link
      to={`/projects/${project.id}`}
      data-testid={`project-card-${project.id}`}
      className="group block"
    >
      <motion.article
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-50px' }}
        transition={{ duration: 0.8, delay: index * 0.1, ease: [0.22, 1, 0.36, 1] }}
        className="relative"
      >
        {/* Image Container - All landscape orientation */}
        <div className="relative overflow-hidden bg-stone-100 aspect-[16/10]">
          <motion.img
            src={project.image_url}
            alt={project.title}
            className="w-full h-full object-cover"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          />
          
          {/* Overlay on hover */}
          <div className="absolute inset-0 bg-stone-900/0 group-hover:bg-stone-900/10 transition-colors duration-500" />
        </div>

        {/* Project Info */}
        <div className="mt-6 space-y-2">
          <div className="flex items-baseline justify-between">
            <h3 className="font-manrope text-lg md:text-xl font-light tracking-tight text-stone-900 group-hover:text-stone-600 transition-colors duration-300">
              {project.title}
            </h3>
            <span className="font-dm-sans text-xs text-stone-400">
              {project.year}
            </span>
          </div>
          <p className="font-dm-sans text-sm text-stone-500">
            {project.location}
          </p>
        </div>
      </motion.article>
    </Link>
  );
};
